import { render, staticRenderFns } from "./LandPageFooter.vue?vue&type=template&id=42f5c1c1&scoped=true&"
import script from "./LandPageFooter.vue?vue&type=script&lang=js&"
export * from "./LandPageFooter.vue?vue&type=script&lang=js&"
import style0 from "./LandPageFooter.vue?vue&type=style&index=0&id=42f5c1c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f5c1c1",
  null
  
)

export default component.exports